import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AddPointService } from "../addPoints/addPoints.service";

@Component({
	selector: "caass-classroom-classroomAttendance-Group-Point-AddPoints",
	templateUrl: "./group-add-points.component.html",
	styleUrls: ["./group-add-points.component.css"],
})
export class GroupAddPointsComponent implements OnInit {
	constructor(private addPointService: AddPointService) {}

	ngOnInit(): void {
		this.loadPointsItem();
	}

	/////////////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////////////

	@Input() AddProcessing: boolean = false;
	@Input() SchoolID: any;
	@Output() onAddGroupPoints: EventEmitter<any> = new EventEmitter<any>();
	@Output() onCancelGroupPoints: EventEmitter<any> = new EventEmitter<any>();

	LoadingPointsItems: boolean = false;
	SelectedPointsItemID: any;
	lstPointsItem: any = [];

	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////////////////////

	loadPointsItem() {
		if (this.SchoolID == undefined || this.SchoolID <= 0) {
			return;
		}

		this.LoadingPointsItems = true;

		var result = this.addPointService.PointsItemGetList(1, this.SchoolID); //CategoryID = 1 is add points
		result.subscribe(
			(response: any) => {
				this.lstPointsItem = response;

				if (this.lstPointsItem.length > 1) {
					this.lstPointsItem.unshift({
						PointsItemID: 0,
						PointsItemDesc: "Choose Point to be awarded",
						PointsItemValue: "",
					});
				}

				this.SelectedPointsItemID = this.lstPointsItem[0].PointsItemID;

				this.LoadingPointsItems = false;
			},
			(error) => {
				this.LoadingPointsItems = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////////////////

	submitClick() {
		this.onAddGroupPoints.emit(this.SelectedPointsItemID);
	}

	cancelClick() {
		this.onCancelGroupPoints.emit(true);
	}

	/////////////////////////////////////////////////////////////////////////////////////////
}
